/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EditMusicEffectsDto } from './EditMusicEffectsDto';
import {
    EditMusicEffectsDtoFromJSON,
    EditMusicEffectsDtoFromJSONTyped,
    EditMusicEffectsDtoToJSON,
    EditMusicEffectsDtoToJSONTyped,
} from './EditMusicEffectsDto';

/**
 * 
 * @export
 * @interface EditMusicClipsDto
 */
export interface EditMusicClipsDto {
    /**
     * 
     * @type {Array<EditMusicEffectsDto>}
     * @memberof EditMusicClipsDto
     */
    effects: Array<EditMusicEffectsDto>;
}

/**
 * Check if a given object implements the EditMusicClipsDto interface.
 */
export function instanceOfEditMusicClipsDto(value: object): value is EditMusicClipsDto {
    if (!('effects' in value) || value['effects'] === undefined) return false;
    return true;
}

export function EditMusicClipsDtoFromJSON(json: any): EditMusicClipsDto {
    return EditMusicClipsDtoFromJSONTyped(json, false);
}

export function EditMusicClipsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMusicClipsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'effects': ((json['effects'] as Array<any>).map(EditMusicEffectsDtoFromJSON)),
    };
}

export function EditMusicClipsDtoToJSON(json: any): EditMusicClipsDto {
    return EditMusicClipsDtoToJSONTyped(json, false);
}

export function EditMusicClipsDtoToJSONTyped(value?: EditMusicClipsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effects': ((value['effects'] as Array<any>).map(EditMusicEffectsDtoToJSON)),
    };
}

